import { render, staticRenderFns } from "./Workbench.vue?vue&type=template&id=5da7d46c&scoped=true&"
import script from "./Workbench.vue?vue&type=script&lang=js&"
export * from "./Workbench.vue?vue&type=script&lang=js&"
import style0 from "./Workbench.vue?vue&type=style&index=0&id=5da7d46c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da7d46c",
  null
  
)

export default component.exports